
import Vue from "vue";
import { mapState } from "vuex";
import { buildBattleyeR2NewAssetCandidates } from "@/constants/battleye-r2-new/assets";
import { BATTLEYE_R2_NEW_EN_HERO } from "@/constants/battleye-r2-new/enCopy";
import { resolveBattleyeR2NewEnAsset } from "@/constants/battleye-r2-new/enAssets";
import { field001Asset } from "@/constants/field-001/assets";

export default Vue.extend({
  data() {
    return {
      battleyeR2HomeKvAssetIndex: 0
    };
  },
  computed: {
    ...mapState("app", {
      isMobile: "isMobile",
      language: "language",
      isCN: "isCN",
      oss: "oss"
    }),
    battleyeR2HomeKvCandidates(): string[] {
      if (!this.isCN) {
        return [
          resolveBattleyeR2NewEnAsset({
            assetPath: this.isMobile
              ? BATTLEYE_R2_NEW_EN_HERO.kvMobile
              : BATTLEYE_R2_NEW_EN_HERO.kv,
            oss: this.oss,
            useOss: true
          }),
          resolveBattleyeR2NewEnAsset({
            assetPath: this.isMobile
              ? BATTLEYE_R2_NEW_EN_HERO.kvMobile
              : BATTLEYE_R2_NEW_EN_HERO.kv,
            oss: this.oss,
            useOss: false
          })
        ];
      }

      const options = {
        assetKey: "battleye_r2_new_nameplate_kv",
        isCN: this.isCN,
        isMobile: this.isMobile,
        oss: this.oss
      };
      return Array.from(
        new Set([
          ...buildBattleyeR2NewAssetCandidates({
            ...options,
            useOss: true
          }),
          ...buildBattleyeR2NewAssetCandidates({
            ...options,
            useOss: false
          })
        ])
      );
    },
    battleyeR2HomeKvSrc(): string {
      return (
        this.battleyeR2HomeKvCandidates[this.battleyeR2HomeKvAssetIndex] || ""
      );
    }
  },
  watch: {
    battleyeR2HomeKvCandidates() {
      this.battleyeR2HomeKvAssetIndex = 0;
    }
  },
  methods: {
    field001HomeAsset(filename: string) {
      return field001Asset(filename, this.oss);
    },
    onOpen(url: string) {
      window.open(url, "_blank");
    },
    onBattleyeR2HomeKvError() {
      if (
        this.battleyeR2HomeKvAssetIndex <
        this.battleyeR2HomeKvCandidates.length - 1
      ) {
        this.battleyeR2HomeKvAssetIndex += 1;
      }
    }
  }
});
